import type { ReactNode } from 'react';
import { PlatformRequireRole } from '@jarvis/platform-ui';
import { useHasRole } from './useHasRole';

interface RequireMediaLibraryProps {
  children: ReactNode;
}

/** Gates Media Library routes to AssistantAdmin or AssistantSysAdmin (not DevOps). */
export function RequireMediaLibrary({ children }: RequireMediaLibraryProps) {
  const { canAccessMediaLibrary } = useHasRole();
  return (
    <PlatformRequireRole
      role="AssistantAdmin or AssistantSysAdmin"
      hasRole={() => canAccessMediaLibrary()}
      roleLabel="Assistant App Role"
    >
      {children}
    </PlatformRequireRole>
  );
}
